import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./lib/store";
import { ThemeProvider } from "./lib/ThemeProvider";
import { ProtectedRoute } from "./components/ProtectedRoute";
import Index from "./pages/Index";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import NotFound from "./pages/NotFound";
import About from "./pages/About";
import Pricing from "./pages/Pricing";
import Guides from "./pages/Guides";
import GuideDetails from "./pages/GuideDetails";
import Profile from "./pages/Profile";
import Contact from "./pages/Contact";
import CreateGuide from "./pages/CreateGuide";
import Checkout from "./pages/Checkout";
import PaymentComplete from "./pages/PaymentComplete";
import "./App.css";
import { USER, USER_TOKEN } from "./api/apiConfig";
import { setUserAction } from "./helpers";

const queryClient = new QueryClient();

const initializeUserState = () => {
  const userString = localStorage.getItem(USER);
  const token = localStorage.getItem(USER_TOKEN);
  if (userString && token) {
    try {
      const user = JSON.parse(userString);
      setUserAction(user);
    } catch (error) {
      console.error('Error parsing user data from localStorage:', error);
    }
  }
};

initializeUserState();

const App = () => (
  <Provider store={store}>
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <Sonner />
          <BrowserRouter>
            <Routes>
              {/* Public routes */}
              <Route path="/" element={<Index />} />
              <Route path="/guides" element={<Guides />} />
              <Route path="/guides/:id" element={<GuideDetails />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />

              {/* Protected routes */}
              <Route element={<ProtectedRoute />}>
                <Route path="/profile" element={<Profile />} />
                <Route path="/create-guide" element={<CreateGuide />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/payment/complete" element={<PaymentComplete />} />
              </Route>

              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </TooltipProvider>
      </QueryClientProvider>
    </ThemeProvider>
  </Provider>
);

export default App;
